import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MunilyAvatarObjectFit, MunilyAvatarSize, MUNILY_AVATAR_DEFAULTS } from './avatar.types';

@Component({
  selector: 'common-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  @Input() imageUrl: string | undefined = undefined;
  @Input() initials: string = MUNILY_AVATAR_DEFAULTS.initials;
  @Input() size: MunilyAvatarSize = MUNILY_AVATAR_DEFAULTS.size;
  @Input() objectFit: MunilyAvatarObjectFit = MUNILY_AVATAR_DEFAULTS.objectFit;
  @Input() backgroundColor: string = MUNILY_AVATAR_DEFAULTS.backgroundColor;
  @Input() alt: string = MUNILY_AVATAR_DEFAULTS.alt;

  get displayInitials(): string {
    return this.initials.slice(0, 2).toUpperCase();
  }
}
